import type { ModeloDefaultProps } from "../../banner-fixo.props"
import ConteudoBanner from "../conteudoBanner/ConteudoBanner"

export default function Modelo03({ data }: Readonly<ModeloDefaultProps>) {

    const banners = data.banners.slice(0, 5)
    const device = data.device

    return (
        <div className="fixed-banners fixed-banners-tipo3 container">
            <div className="item-banner flex center justify-center">
                <div className="banner-column flex column">
                    {banners.slice(0, 2).map(currentBanner => (
                        <ConteudoBanner key={currentBanner.id} data={{
                            banner: currentBanner,
                            device: data.device
                        }} />
                    ))}
                </div>

                {banners[2] && (
                    <div className="banner-size">
                        <ConteudoBanner data={{
                            banner: banners[2],
                            device
                        }} />
                    </div>
                )}

                <div className="banner-column flex column">
                    {banners.slice(3, 5).map(currentBanner => (
                        <ConteudoBanner key={currentBanner.id} data={{
                            banner: currentBanner,
                            device
                        }} />
                    ))}
                </div>
            </div>
        </div>
    )
}